<script setup>
import { ref, inject, watch } from 'vue';
import { normerNom, TypeNommage } from '@/scripts/global.js';
import { 
    getErreurNomNorme,
    getErreurTexteRequis } from '@/scripts/controlesSaisie.js';
import { apiAjouterListeValeurs } from '@/services/ServiceModele.js';
import Dialog from 'primevue/dialog';
import Formulaire from '@/components/generiques/Formulaire.vue';
import SaisieTexte from '@/components/generiques/SaisieTexte.vue';

const schema = inject('schema');
const selectionnerListeValeurs = inject('selectionnerListeValeurs');
const appelerApiModifModele = inject('appelerApiModifModele');
const afficherSucces = inject('afficherSucces');
const affichage = inject('affichageModaleAjoutListeValeurs');

const nouvelleListeValeurs = ref(getListeValeursInitiale());

watch(() => affichage.value, (affichage) => {
    if (affichage) {
        nouvelleListeValeurs.value = getListeValeursInitiale();
    }
})

watch(() => nouvelleListeValeurs.value.libelle, (nouveauLibelle, ancienLibelle) => {
    if (!nouvelleListeValeurs.value.nom || nouvelleListeValeurs.value.nom === normerNom(ancienLibelle, TypeNommage.CLASSE)) {
        nouvelleListeValeurs.value.nom = normerNom(nouveauLibelle, TypeNommage.CLASSE);
    }
});

function getListeValeursInitiale() {
    return {
        nom: null,
        libelle: null
    };
}

function validerSaisie(listeValeurs) {
    const erreurs = {};
    erreurs.nom = getErreurNomNorme(listeValeurs.nom, TypeNommage.CLASSE);
    erreurs.libelle = getErreurTexteRequis(listeValeurs.libelle);
    return erreurs;
}

function validerFormulaire() {
    nouvelleListeValeurs.value.validationFormulaire = true;
}

function ajouterListeValeurs() {
    const listeValeurs = {
        id: null,
        nom: nouvelleListeValeurs.value.nom, 
        libelle: nouvelleListeValeurs.value.libelle,
        valeurs: []
    };
    appelerApiModifModele(apiAjouterListeValeurs, listeValeurs, (reponseOK) => {
        if (reponseOK) {
            const listeValeursCreee = schema.value.listesValeurs.find(liste => liste.nom === listeValeurs.nom);
            selectionnerListeValeurs(listeValeursCreee);
            afficherSucces('Liste de valeurs créée');
            affichage.value = false;
        }
    });
}

</script>

<template>
    <Dialog 
    v-model:visible="affichage"
    :modal="true">
        <template #header>
            <label class="titre">Ajout d'une liste de valeurs</label>
        </template>
        <Formulaire
            :objet="nouvelleListeValeurs"
            :fonction-validation-saisie="validerSaisie"
            @validation="ajouterListeValeurs">
            <label class="intitule">Libellé :</label>
            <SaisieTexte v-model:valeur="nouvelleListeValeurs.libelle" :id-erreur="'libelle'" :autofocus="true" />
            <label class="intitule">Nom :</label>
            <SaisieTexte v-model:valeur="nouvelleListeValeurs.nom" :id-erreur="'nom'" />
        </Formulaire>
        <template #footer>
            <button 
                class="bouton fas fa-check" 
                @click="validerFormulaire()"/>
        </template>
    </Dialog>
</template>

<style scoped>

.titre {
    margin-right: 10px;
}

</style>